import { render } from "./LightboxFrequency.vue?vue&type=template&id=f44c6d44&scoped=true"
import script from "./LightboxFrequency.vue?vue&type=script&lang=js"
export * from "./LightboxFrequency.vue?vue&type=script&lang=js"

import "./LightboxFrequency.vue?vue&type=style&index=0&id=f44c6d44&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44c6d44"]])

export default __exports__